import { Vue } from 'vue-property-decorator'
/* api */
import LogoutApi from '@/app/model/api/logoutApi'
import AuthCheckApi from '@/app/model/api/authCheckApi'
import ConstantValueApi from '@/app/model/api/constantValueApi'
import WeedAlarmListApi from '@/app/model/api/weedAlarmListApi'
import ServiceFunctionApi from '@/app/model/api/serviceFunctionApi'
/* module */
import Local from '@/app/module/local'
import Session from '@/app/module/session'
import DateClass from '@/app/module/date'
import store from '@/store'
import route from '@/router'
import { routerPath, errorFlag } from '@/app/model/store/domain/const'

class CommonClass {
  public doLogout () {
    // cacheStorageをクリア
    caches.keys().then(function (keyList) {
      return Promise.all(keyList.map(function (key) {
        return caches.delete(key)
      }))
    })

    const bodyData = {
      token: Local.getAuthToken()!
    }

    // ローカルストレージをクリア
    localStorage.clear()
    sessionStorage.clear()

    // 検索状態を保持していたものを削除
    store.commit('fieldState/setListRefile', true)
    store.commit('fieldState/setSearchStatus', 0)
    store.commit('fieldState/setSearchVariety', '')
    store.commit('fieldState/setSearchGrade', '')
    store.commit('fieldState/setSearchRisk', 0)
    store.commit('fieldState/setSearchText', '')
    store.commit('fieldState/setAccordionType', '1')
    store.commit('fieldState/setSortOrder', 'harvestForecastDays')
    store.commit('fieldState/setSort', 'asc')

    // ログアウトの際にはフラグをリセットする
    store.commit('setFlagState/setGraphDialogFlag', false)
    store.commit('setFlagState/setImgFlag', false)
    store.commit('setFlagState/setMainImgFlag', false)
    store.commit('setFlagState/setSensorDataFlag', false)
    store.commit('setFlagState/setSelectDataListFlag', false)
    store.commit('setFlagState/setMySelectDataListFlag', false)
    store.commit('setFlagState/setMyApiKeyFlag', true)
    store.commit('setFlagState/setFieldDetailsDataFlag', false)
    store.commit('setFlagState/setGraphMasterDataFlag', false)
    store.commit('setFlagState/setPlantingIdFlag', false)

    LogoutApi.doLogout(bodyData)
    route.push(routerPath.PATH_LOGIN)

    // リロード
    window.location.reload()
  }

  public doSpLogout () {
    // cacheStorageをクリア
    caches.keys().then(function (keyList) {
      return Promise.all(keyList.map(function (key) {
        return caches.delete(key)
      }))
    })

    const bodyData = {
      token: Local.getAuthToken()!
    }

    // ローカルストレージをクリア
    localStorage.clear()
    sessionStorage.clear()

    LogoutApi.doLogout(bodyData)
    route.push(routerPath.PATH_SP_LOGIN)

    // リロード
    window.location.reload()
  }

  /* 認証チェック */
  public async authCheck () {
    /* 認証API */
    let result = await AuthCheckApi.checkAuth()

    if (result.isOk()) {
      Local.setUserName(result.getPayload().user_name)
      Local.setUserId(result.getPayload().user_id)
      Local.setUserType(result.getPayload().type)
    } else if (result.getPayload().status_code === '401') {
      // トークン空or期限切れ=ログアウトする
      this.doLogout()
    }
  }

  /* 認証チェック(30分毎) */
  public async consecutiveCheck () {
    // 30分＝1800秒
    setInterval(this.authCheck, 1800000)
  }

  public async clearConstantValue (route: string) {
    if (localStorage['constantValue'] !== undefined) {
      // ローカルストレージのタイムスタンプ
      let data = new Date(JSON.parse(localStorage['constantValue']).timestamp)
      // 期限日(次の日の7:00)
      let timeLimit = new Date('' + data.getFullYear() + '-' + DateClass.toDoubleDigits(data.getMonth() + 1) + '-' + DateClass.toDoubleDigits(data.getDate() + 1) + 'T07:00:00')
      // 今
      let now = new Date()

      if (now > timeLimit) {
        await localStorage.removeItem('constantValue')
        this.getConstantValue(route)
      }
    } else {
      this.getConstantValue(route)
    }
  }

  // システム定義値取得
  private getConstantValue (path: string) {
    (async () => {
      const result = await ConstantValueApi.getConstantValue()
      store.commit('routeState/setRoute', path)

      if (result.isOk()) {
        const constantValue = result.getPayload()
        constantValue.timestamp = Date.now()
        await Local.setConstantValue(JSON.stringify(constantValue))
      } else if (result.getPayload().status_code === '403') {
        // 権限エラー(403ページへ遷移)
        store.commit('routeState/setRoute', path)
        store.commit('routeState/setErrorFlag', errorFlag.ERROR_FLAG_AUTH)
        if (path.indexOf('sp') === -1) {
          route.push(routerPath.PATH_ERROR_PAGE)
        } else {
          route.push(routerPath.PATH_SP_ERROR_PAGE)
        }
      } else if (result.getPayload().status_code === '401') {
        // token切れ
        if (path.indexOf('sp') === -1) {
          this.doLogout()
        } else {
          this.doSpLogout()
        }
      } else {
        // 500系もしくはbodyがない場合と、その他
        store.commit('routeState/setRoute', path)
        store.commit('routeState/setErrorFlag', errorFlag.ERROR_FLAG_SERVER)
        if (path.indexOf('sp') === -1) {
          route.push(routerPath.PATH_ERROR_PAGE)
        } else {
          route.push(routerPath.PATH_SP_ERROR_PAGE)
        }
      }
    })()
  }

  /* サービス機能設定取得し、ローカルストレージにセット */
  public async setServiceFunctionData (path: string) {
    await (async () => {
      if (path === undefined) {
        path = 'pc'
      }
      const result = await ServiceFunctionApi.getServiceFunctionData()

      if (result.isOk()) {
        const serviceFunctionValue = result.getPayload()
        // ローカルストレージのサービス機能設定を削除
        if (localStorage['serviceFunctionValue'] !== undefined) {
          await localStorage.removeItem('serviceFunctionValue')
        }
        // セット
        await Local.setServicdeFunctionValue(JSON.stringify(serviceFunctionValue))
      } else if (result.getPayload().status_code === '401') {
        // token切れ
        if (path === 'pc') {
          this.doLogout()
        } else {
          this.doSpLogout()
        }
      } else {
        // 500系もしくはbodyがない場合と、その他
        store.commit('routeState/setErrorFlag', errorFlag.ERROR_FLAG_SERVER)
        if (path === 'pc') {
          route.push(routerPath.PATH_ERROR_PAGE)
        } else {
          route.push(routerPath.PATH_SP_ERROR_PAGE)
        }
      }
    })()
  }

  public async clearWeedAlarmCount () {
    if (localStorage['weedAlarmCount'] !== undefined) {
      // ローカルストレージのタイムスタンプ
      let data = new Date(JSON.parse(localStorage['weedAlarmCount']).timestamp)
      // 期限日(次の日の7:00)
      let timeLimit = new Date(data.getFullYear(), data.getMonth(), data.getDate(), data.getHours() + 3, data.getMinutes(), data.getSeconds())
      // 今
      let now = new Date()

      if (now.getTime() > timeLimit.getTime()) {
        await localStorage.removeItem('weedAlarmCount')
        this.getWeedAlarmList()
      }
    } else {
      this.getWeedAlarmList()
    }
  }

  private getWeedAlarmList () {
    (async () => {
      const result = await WeedAlarmListApi.getWeedAlarmList()

      if (result.isOk()) {
        // ヘッダー表示用
        const weedAlarmCount = {
          timestamp: Date.now(),
          total_count: result.getPayload().total_count
        }
        await Local.setWeedAlarmCount(JSON.stringify(weedAlarmCount))
        store.commit('weedState/setTotalCountFlag', true)
      } else {
        const errorData = this.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
    })()
  }

  public getServiceFunctionData () {
    const serviceFunc: any = JSON.parse(Local.getServiceFunctionValue()!)
    return serviceFunc
  }

  /* グローバル変数にデータを追加 */
  public setGrowthData (val: any, $event: any) {
    // idからidとstepを切り出す
    let index = val.id.indexOf('/')
    let step = val.id.slice(index + 1)
    let growthData

    // ステージの日付を求める
    let growthDataList = JSON.parse(Session.getGrowthStage()!)
    for (let i in growthDataList) {
      if (growthDataList[i].growth_step === parseInt(step)) {
        growthData = growthDataList[i]
      }
    }
    let plantingDate = DateClass.formingDate(Session.getPlantingDay()!)
    let newDate = new Date(plantingDate.getTime() + (growthData.elapsed_days * 24 * 60 * 60 * 1000))
    let stageDate = DateClass.toDoubleDigits(newDate.getMonth() + 1) + '/' + DateClass.toDoubleDigits(newDate.getDate())

    // 必要なデータをグローバル変数に格納
    Vue.prototype.$globalGrowthData = growthData
    Vue.prototype.$globalStageDate = stageDate

    Vue.prototype.$globalElX = $event.clientX

    // データ変更フラグ
    store.commit('setFlagState/setGrowthDialogFlag', true)
  }

  public stringCut (data: string) {
    if (data !== '' && data !== undefined) {
      if (data.length > 18) {
        return data.substr(0, 17) + '…'
      } else {
        return data
      }
    }
  }

  // 桁数千円以上の場合
  public checkLength (val: number) {
    if (String(val).length >= 4) {
      let number = parseInt(String(val).substr(0, String(val).length - 3).toLocaleString())
      return number.toLocaleString() + '千'
    } else {
      return val.toLocaleString()
    }
  }

  public doErrorHandring (data: any, terminalType: string, requestMethod: string, errorType: string) {
    if (data.status_code === '400') {
      // エラーアラートもしくはテキストを表示
      if (errorType === 'text') {
        let errors: any = []
        if (requestMethod === 'GET' || requestMethod === 'DELETE') {
          for (var i in data.errors) {
            errors.push(data.errors[i].message)
          }
          data.alertTitle = errors.join('<br/>')
          data.alertText = ''
        } else {
          errors.push('<ul>')
          for (var j in data.errors) {
            errors.push('<li>' + data.errors[j].message + '</li>')
          }
          errors.push('</ul>')
          data.alertTitle = ''
          data.alertText = errors.join('')
        }
      } else {
        let errors: any = []
        for (var k in data.errors) {
          errors.push(data.errors[k].message)
        }
        const text = errors.join('\n')
        Vue.prototype.$alert.toast({ text: text, type: 1 })
      }
    } else if (data.status_code === '401') {
      // トークンエラー(強制ログアウトしログイン画面に遷移)
      if (terminalType === 'sp') {
        this.doLogout()
      } else {
        this.doSpLogout()
      }
    } else if (data.status_code === '409') {
      // 排他処理(409モーダルを表示)
    } else {
      if (data.status_code === '403') {
        // NoFoundエラー(403エラー文を表示)
        store.commit('routeState/setErrorFlag', errorFlag.ERROR_FLAG_AUTH)
      } else if (data.status_code === '404') {
        // 権限エラー(404エラー文を表示)
        store.commit('routeState/setErrorFlag', errorFlag.ERROR_FLAG_DEFAULT)
      } else {
        // その他500系エラー(サーバーエラー文を表示)
        store.commit('routeState/setErrorFlag', errorFlag.ERROR_FLAG_SERVER)
      }

      // エラーページへ遷移
      if (terminalType === 'sp') {
        route.push(routerPath.PATH_SP_ERROR_PAGE).catch(e => {})
      } else {
        route.push(routerPath.PATH_ERROR_PAGE).catch(e => {})
      }
    }

    return data
  }

  public displayPlantingType (key: number) {
    switch (key) {
      case Number(process.env.VUE_APP_PLANTING_TYPE_KEY1):
        return process.env.VUE_APP_PLANTING_TYPE_NAME1

      case Number(process.env.VUE_APP_PLANTING_TYPE_KEY2):
        return process.env.VUE_APP_PLANTING_TYPE_NAME2

      case Number(process.env.VUE_APP_PLANTING_TYPE_KEY3):
        return process.env.VUE_APP_PLANTING_TYPE_NAME3

      default:
        break
    }
  }
}

export default new CommonClass()
